import React, { useEffect, useState } from "react";
import RequestHandler from "../Functions/RequestHandler";
import { toast } from "react-toastify";

const ReportModal = ({ data, setData, isOpen, closeModal }) => {
	const handlePrint = () => {
		const printContent = document.getElementById("report-content");
		const printWindow = window.open("", "_blank");
        if (printWindow === null) {
            return;
        }
		printWindow.document.write(printContent!.innerHTML);
		printWindow.document.close();
		printWindow.print();
	};

	const loadRequestData = async () => {
		if (data !== null) return;
		try {
			const data = await RequestHandler.handleRequest(
				"post",
				"orders/getAllOrderRevenue"
			);
			if (data.success === false) {
				toast.error(
					data.message ||
						"Error occurred. Please check your credentials."
				);
			} else {
				setData(data);
			}
		} catch (error) {
			toast.error(`An error occurred while requesting data. ${error}`);
		}
	};

	useEffect(() => {
		loadRequestData();
	}, []);


	if (!isOpen) return null;
	return (
		<>
			{data !== null && (
				<div
					className="fixed inset-0 flex justify-center items-center bg-gray-500 bg-opacity-75 z-50"
					onClick={closeModal}
				>
					<div
						className="bg-white rounded-lg shadow-lg p-8 w-11/12 max-w-4xl"
						onClick={(e) => e.stopPropagation()}
					>
						<h2 className="text-xl font-bold mb-4">Sales Report</h2>

						<div
							id="report-content"
							className="max-h-[600px] overflow-y-auto"
						>
							{/* Total Metrics */}
							<div className="mb-6">
								<h3 className="text-lg font-semibold">
									Total Metrics
								</h3>
								<table className="min-w-full table-auto border-collapse">
									<tbody>
										<tr>
											<td className="border px-4 py-2">
												Total Revenue
											</td>
											<td className="border px-4 py-2">
												₱{data.totalRevenue}
											</td>
										</tr>
										<tr>
											<td className="border px-4 py-2">
												Total Orders
											</td>
											<td className="border px-4 py-2">
												{data.totalOrders}
											</td>
										</tr>
										<tr>
											<td className="border px-4 py-2">
												Average Order Value
											</td>
											<td className="border px-4 py-2">
												₱{data.averageOrderValue}
											</td>
										</tr>
										<tr>
											<td className="border px-4 py-2">
												Total Discounts
											</td>
											<td className="border px-4 py-2">
												₱{data.totalDiscounts}
											</td>
										</tr>
										{/* <tr>
									<td className="border px-4 py-2">
										Repeat Customers
									</td>
									<td className="border px-4 py-2">
										{data.repeatCustomerCount}
									</td>
								</tr> */}
									</tbody>
								</table>
							</div>

							{/* Top Products */}
							<div className="mb-6">
								<h3 className="text-lg font-semibold">
									Top-Selling Products
								</h3>
								<table className="min-w-full table-auto border-collapse">
									<thead>
										<tr>
											<th className="border px-4 py-2">
												Product Name
											</th>
											<th className="border px-4 py-2">
												Units Sold
											</th>
										</tr>
									</thead>
									<tbody>
										{data.topProducts.map(
											(product, index) => (
												<tr key={index}>
													<td className="border px-4 py-2">
														{product.name}
													</td>
													<td className="border px-4 py-2">
														{product.count}
													</td>
												</tr>
											)
										)}
									</tbody>
								</table>
							</div>

							{/* Top Product Revenue */}
							<div className="mb-6">
								<h3 className="text-lg font-semibold">
									Top Product Revenue
								</h3>
								<table className="min-w-full table-auto border-collapse">
									<thead>
										<tr>
											<th className="border px-4 py-2">
												Product Name
											</th>
											<th className="border px-4 py-2">
												Revenue
											</th>
										</tr>
									</thead>
									<tbody>
										{data.topProductRevenue.map(
											(product, index) => (
												<tr key={index}>
													<td className="border px-4 py-2">
														{product.name}
													</td>
													<td className="border px-4 py-2">
														₱{product.revenue}
													</td>
												</tr>
											)
										)}
									</tbody>
								</table>
							</div>

							{/* Sales Over Time */}
							<div className="mb-6">
								<h3 className="text-lg font-semibold">
									Sales Over Time
								</h3>
								<table className="min-w-full table-auto border-collapse">
									<thead>
										<tr>
											<th className="border px-4 py-2">
												Month
											</th>
											<th className="border px-4 py-2">
												Total Sales
											</th>
											<th className="border px-4 py-2">
												Revenue
											</th>
										</tr>
									</thead>
									<tbody>
										{data.salesOverTime.map(
											(entry, index) => (
												<tr key={index}>
													<td className="border px-4 py-2">
														{entry.month}
													</td>
													<td className="border px-4 py-2">
														{entry.totalSales}
													</td>
													<td className="border px-4 py-2">
														₱{entry.revenue}
													</td>
												</tr>
											)
										)}
									</tbody>
								</table>
							</div>

							{/* Category Sales Orders */}
							<div className="mb-6">
								<h3 className="text-lg font-semibold">
									Category Sales Orders
								</h3>
								<table className="min-w-full table-auto border-collapse">
									<thead>
										<tr>
											<th className="border px-4 py-2">
												Category
											</th>
											<th className="border px-4 py-2">
												Sales
											</th>
											<th className="border px-4 py-2">
												Orders
											</th>
										</tr>
									</thead>
									<tbody>
										{data.categorySalesOrders.map(
											(category, index) => (
												<tr key={index}>
													<td className="border px-4 py-2">
														{category.category}
													</td>
													<td className="border px-4 py-2">
														₱{category.sales}
													</td>
													<td className="border px-4 py-2">
														{category.orders}
													</td>
												</tr>
											)
										)}
									</tbody>
								</table>
							</div>
						</div>

						{/* Close and Print Buttons */}
						<div className="flex justify-between mt-6">
							<button
								onClick={closeModal}
								className="bg-red-500 text-white px-4 py-2 rounded-md"
							>
								Close
							</button>
							<button
								onClick={handlePrint}
								className="bg-blue-500 text-white px-4 py-2 rounded-md"
							>
								Print Report
							</button>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default ReportModal;
